type ToastMode = 'neutral' | 'success' | 'warning' | 'failure'

interface Toast {
  title: string
  message?: string
  mode: ToastMode
}

export function useToast() {
  const toast: Ref<Toast | null> = useState('toast', () => null)

  //To show a toast just call this function, give it a 'title', 'message, and 'mode'(e.g. 'success', 'failure', 'warning')
  const showToast = (newToast: Toast) => {
    toast.value = newToast
  }

  const clearToast = () => {
    toast.value = null
  }

  return {
    toast,
    showToast,
    clearToast,
  }
}
